import { GENERIC_STATES } from './misc';

export const FLOOR_PLAN_STATE = {
  ...GENERIC_STATES,
  PROCESSING: 'PROCESSING',
};
